import { Component, EventEmitter,  Output, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LazyLoadEvent } from 'primeng/api';
import { BaseViewComponent } from '../../../../../../projects/shared/core/interfaces/baseViewComponent';
import { LookupService } from '../../../../../../projects/shared/core/services/lookup.service';
import { ToastService } from '../../../../../../projects/shared/core/services/toast.service';
import { RmsLoadingService } from '../../../../../../projects/rms/app/shared/ui-rms/components/loading-spinner/rms-loading.service';
import { ResponderModel } from '../../../../../../projects/rms/app/api/models/responder-model';
import { ResponderService } from '../../../../../../projects/rms/app/api/services/responder.service';
import { TeamModel } from '../../../../../../projects/rms/app/api/models/team-model';
import { TeamService } from '../../../../../../projects/rms/app/api/services/team.service';
import { ResponderSearchComponent } from './responder-search/responder-search.component';
import { FindFilter } from '../../../../../../projects/rms/app/api/models/find-filter';

@Component({
  selector: 'ndms-search-responders-modal',
  templateUrl: './search-responders-modal.component.html',
  styleUrls: ['./search-responders-modal.component.css']
})
export class SearchRespondersModalComponent extends BaseViewComponent {
  @ViewChild(ResponderSearchComponent) searchResponder: ResponderSearchComponent;

  @Output() cancel = new EventEmitter<boolean>();
  @Output() selection = new EventEmitter<ResponderModel>();

  private _responders$: BehaviorSubject<ResponderModel[]> = new BehaviorSubject<ResponderModel[]>([]);
  get responders$() {
    return this._responders$.asObservable();
  }
  get responders() {
    return this._responders$.value;
  }

  teams: TeamModel[] = [];

  selectedItem: ResponderModel;
  filter: FindFilter = {
    findKeys: {},
    includes: ["ResponderTeams"],
    pagingInfo: {
      "pageNumber": 0,
      "pageSize": 10
    },
    sortInfos: [
      {
        columnName: "LastName",
        isDescending: false
      },
      {
        columnName: "FirstName",
        isDescending: false
      }]
  };
  searchKeyValues: any = {};
  firstItem: number = 0;
  count: number = 0;
  pageSize: number = 10;
  displayList: boolean = false;
  modelError: string = "";
  columns: any[] = [
    { header: "Responder", field: "responderName" },
    { header: "Primary Team", field: "primaryTeam" }
  ];

  constructor(
    private _responderService: ResponderService,
    private _teamService: TeamService,
    private _toastService: ToastService,
    private _loadingService: RmsLoadingService,
    lookupService: LookupService) {
    super(lookupService);

    this.getTeams();
  }

  onCancelClick() {
    this.cancel.emit(false);
  }

  onClear(clearSearch: boolean) {
    if (clearSearch) {
      this.displayList = false;
    }
  }

  onReloadList(event: LazyLoadEvent) {
    if (!this.displayList || this.teams.length === 0) {
      return;
    }
    let direction = event.sortOrder === -1 ? true : false;
    let sortInfo = [];
    switch (event.sortField) {
      case "responderName":
        sortInfo = [
          {
            columnName: "LastName",
            isDescending: direction
          },
          {
            columnName: "FirstName",
            isDescending: direction
          },
          {
            columnName: "MiddleName",
            isDescending: direction
          },
          {
            columnName: "SuffixName",
            isDescending: direction
          }];
        break;
      case "primaryTeam":
        sortInfo = [
          {
            columnName: "PrimaryTeamName",
            isDescending: direction
          }];
        break;
    }

    this.firstItem = event.first;
    let pageNumber = this.firstItem / event.rows;
    
    this.filter.pagingInfo = { "pageNumber": pageNumber, "pageSize": event.rows };
    this.filter.sortInfos = sortInfo;
    this.getResponders(false);
  }
  
  onSearch(event) {
    this.displayList = true;
    if (event["FirstName"] != this.filter.findKeys["FirstName"] ||
        event["LastName"] != this.filter.findKeys["LastName"] ||
        event["ResponderTeams.TeamId"] != this.filter.findKeys["ResponderTeams.TeamId"]) {
      this.firstItem = 0;
      this.filter.pagingInfo.pageNumber = 0;
    }
    this.searchKeyValues = Object.assign(this.searchKeyValues, event);
    this.filter.findKeys = this.searchKeyValues;
    this.getResponders(true);
  }
  
  onSelectClick(event) {
    this.selection.emit(event);
  }

  private getResponders(searching: boolean) {
    let getData = new Promise<void>((resolve, reject) => {
      this.safeSubscribe(this._responderService.FindInDomain(this.filter), data => {
        this._responders$.next(data);
        this.count = data.TotalRecordCount;
        if (searching) {
          this.searchResponder.onSearchComplete();
        }
        return resolve();
      }, error => {
        this._toastService.showError(error);
        reject();
      });
    });

    let options = {
      key: 'SearchRespondersModalComponent',
      message: 'Searching...',
      cbPromise: getData
    };
    return this._loadingService.setLoading(options);
  }

  private getTeams() {
    let findFilter = Object.assign({}, {
      findKeys: {
        "Active": "true"
      },
      pagingInfo: {
        "pageNumber": 0,
        "pageSize": 1000
      },
      sortInfos: [{ "columnName": "TeamName", "isDescending": false }]
    });
    return new Promise<void>((resolve, reject) => {
      this.safeSubscribe(this._teamService.FindInDomain(findFilter), data => {
        this.teams = data;
        return resolve();
      }, error => {
        this._toastService.showError(error);
        reject();
      });
    });
  }

}
